import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/_layout/documents/")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/documents/company" });
  },
});
